import CustomerAccountRegistrationFormTeplarnyBrno from "features/registration/components/customerAccountRegistration/CustomerAccountRegistrationFormTeplarnyBrno";
import TopBarIconsTeplarnyBrno from "features/shared/layout/topbar/components/topBarIcons/TopBarIconsTeplarnyBrno";

interface ComponentMap {
  [key: string]: (props?: any) => JSX.Element;
}

export const DynamicComponetsRegistry: ComponentMap  = {
  // TeplarnyBrno
  "CustomerAccountRegistrationFormTeplarnyBrno": CustomerAccountRegistrationFormTeplarnyBrno,
  "TopBarIconsTeplarnyBrno": TopBarIconsTeplarnyBrno
}